import React, { Component, PropTypes } from 'react'
import Associations from '../associations'
import api from '../../api'
import RaisedButton from 'material-ui/RaisedButton'

const styles = {
  form: {
    padding: '0 40px'
  },
  h3: {
    paddingTop: '20px',
    paddingBottom: '10px'
  },
  radio: {
    marginRight: '10px'
  }
}
class InstitutionAnswers extends Component<any, any> {
  constructor () {
    super()
    this.state = {
      answers: [],
      questions: [],
      defaultAnswers: [],
      successStyles: { display: 'none' }
    }
  }

  componentWillMount () {
    this.populateAnswerDefaults()
    this.populateQuestions()
  }

  populateQuestions () {
    const body = {}

    return api.get('admin/institution_questions', { body })
      .then(res => {
        return res.json()
      })
      .then(data => {
        this.setState({ questions: data })
        return data
      })
  }

  populateAnswerDefaults () {
    const body = {}

    return api.get('admin/institution_answer_defaults', { body })
      .then(res => {
        return res.json()
      })
      .then(data => {
        this.setState({
          defaultAnswers: data.reduce(
            (a, r) => {
              if (!a[r.institution_question_id]) {
                a[r.institution_question_id] = []
              }
              a[r.institution_question_id].push(r)
              return a
            }, {})
        })
        return data
      })
  }

  populateAnswers (institutionId) {
    const body = { filter: { institution_id: institutionId } }

    return api.get('admin/institution_answers', { body })
      .then(res => {
        return res.json()
      })
      .then(data => {
        this.setState({
          institutionId: institutionId,
          answers: data.reduce(
            (a, r) => {
              a[r.institution_question_id] = r
              return a
            }, { })
        })
        this.setState({
          existingAnswers: data.reduce(
            (a, r) => {
              a[r.institution_question_id] = r
              return a
            }, {})
        })
// @ts-ignore
        this.answersLoaded = true
        return data
      })
  }

  renderAnswers (questionId) {
    const name = `question-${questionId}`
    const { answers } = this.state
    const selectAnswer = (questionId, answer) => {
      const newAnswers = Object.assign({}, this.state.answers, { [questionId]: { answer } })
      this.setState({ answers: newAnswers })
    }
    let standardAnswerFound = false
    return (
      <div>
        {
          this.state.defaultAnswers[questionId].map((defaultAnswer, i) => {
            let checked = false
            if (answers[questionId] && answers[questionId].answer === defaultAnswer.answer) {
              checked = true
              standardAnswerFound = true
            }

            return (
              <div key={i}>
                <input
                  style={styles.radio}
                  checked={checked}
                  type='radio'
                  value={defaultAnswer.answer}
                  name={name}
                  id={`answer-${questionId}-${defaultAnswer.id}`}
                  onClick={() => selectAnswer(questionId, defaultAnswer.answer)}
                />
                <label htmlFor={`answer-${questionId}-${defaultAnswer.id}`}>{defaultAnswer.answer}</label>
              </div>
            )
          })
        }
        <div>
          <label>Other:</label>
          <input
            id={`${name}-other`}
            type='text'
            defaultValue={!standardAnswerFound && answers[questionId] ? answers[questionId].answer : ''}
            onChange={(e) => {
              selectAnswer(questionId, e.target.value)
            }}
          />
        </div>
      </div>
    )
  }

  renderQuestion (question, key) {
    return (
      <div key={`question-${key}`}>
        <h3 style={styles.h3}>
          {question.question}
        </h3>
        {this.state.existingAnswers && this.renderAnswers(question.id)}
      </div>
    )
  }

  renderQuestions (questions) {
    return questions.map((question, key) => this.renderQuestion(question, key))
  }

  onSubmit () {
    Object.keys(this.state.answers).forEach(questionId => {
      let method
      let path
      const answer = this.state.existingAnswers[questionId]
      if (this.state.existingAnswers[questionId]) {
        method = api.patch
        path = `admin/institution_answers/${answer.id}`
      } else {
        method = api.post
        path = 'admin/institution_answers'
      }
      const body = {
        answer: this.state.answers[questionId].answer,
        institution_id: this.state.institutionId,
        institution_question_id: questionId
      }
      method(path, { body })
        .then(() => {
          this.populateAnswers(this.state.institutionId)
          this.setState({
            successStyles: {
              color: 'green',
              animation: 'fadeOut 2s forwards',
              display: 'block'
            }
          })
          setTimeout(() => {
            this.setState({
              successStyles: {
                display: 'none'
              }
            })
          }, 2001)
        })
    })
  }

  render () {
// @ts-ignore
    if (!this.answersLoaded) {
      this.populateAnswers(this.props.params.institutionId)
    }
    const fadeStyle = `
      @keyframes fadeOut {
        from {opacity: 1}
        to {opacity: 0}
      }
    `
    return (
      <form style={styles.form}>
        <style>
          {fadeStyle}
        </style>
        {this.renderQuestions(this.state.questions)}
        <RaisedButton
          label='Save'
          primary
          onClick={() => this.onSubmit()}
        />
        <div style={this.state.successStyles}>
          Saved Answers ✔
        </div>
      </form>
    )
  }
}

// @ts-ignore
Associations.propTypes = {
  title: PropTypes.string.isRequired,
  baseRecord: PropTypes.object.isRequired
}

export default InstitutionAnswers
